import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormEntryComponentClass, FormComponentLookup } from '@ptl/forms';

@FormComponentLookup('add-whb-question')
@Component({
    selector: 'app-add-whb-question',
    templateUrl: './add-whb-question.component.html',
    styleUrls: ['./add-whb-question.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class addWhbQuestionComponent extends FormEntryComponentClass {

  @ViewChild('entryRef') entryRef: ElementRef;

  constructor() {
    super();
  }

}
